var OrderedCollection, Question, Questions,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

OrderedCollection = require('models/base/ordered_collection');

Question = require('models/question');

module.exports = Questions = (function(_super) {
  __extends(Questions, _super);

  function Questions() {
    return Questions.__super__.constructor.apply(this, arguments);
  }

  Questions.prototype.model = Question;

  Questions.prototype.initialize = function() {
    Questions.__super__.initialize.apply(this, arguments);
    return _.extend(this, new Backbone.Memento(this));
  };

  Questions.prototype.pouch = {
    fetch: 'questions',
    views: {
      questions: {
        map: function(doc) {
          if (doc.docType === 'question') {
            return emit(doc.docType, doc);
          }
        }
      }
    },
    filters: {
      questions: function(doc) {
        return doc._deleted || doc.docType === 'question';
      }
    }
  };

  return Questions;

})(OrderedCollection);
